<template>
    <div class="app">
        <TopNav></TopNav>
        <div class="center">
            <!-- 背景图模块 -->
            <div class="pic">
                <div class="w">
                    <div>
                        <img src="../assets/xw-pic1.png" alt="新闻图片1">
                        <h3>2022中央一号文件来了！</h3>
                        <p>2022年中央一号文件于2月22日正式发布。这份文件题为《中共中央国务院关于做好2022年全面推进乡村振兴重点工作的意见》</p>
                    </div>
                    <div>
                        <img src="../assets/xw-pic2.png" alt="新闻图片2">
                        <h3>图说调查报告：2021年农贸市场发展情况</h3>
                        <p>全方面分析2021农贸市场发展情况，智慧化农贸市场迎来机遇与挑战！</p>
                    </div>
                    <div>
                        <img src="../assets/al1.jpg" alt="新闻图片3">
                        <h3>西安市霖昌易购乐市场盛大开业！</h3>
                        <p>霖昌易购乐市场经过改造升级，5月20日盛大开业！开业当日，前来买菜的居民络绎不绝，升级后的市场，作为社区邻里中心，不仅汇集民生优惠，更凝聚着智慧高科技。</p>
                    </div>
                </div>
            </div>
            <div class="content_row">
                <!-- 历史模块 -->
                <div class="history">
                    <div class="title_content">
                        <div class="title">
                            <img src="../assets/tb.png" style="margin-right: .4rem;" alt="">
                            <h1>精英团队旗下，深耕行业多年</h1>
                            <img src="../assets/tb 1.png" style="margin-left: .4rem;" alt="">
                        </div>
                        <p>以市场为导向，与客户共成长</p>
                    </div>
                    <div class="history-time">
                        <div>
                            <h2>
                                <countTo :startVal=0 :endVal="20" :duration='3000' class="count" :decimals="0">
                                </countTo>
                                +<span>年</span>
                            </h2>
                            <p>智慧化解决方案积累</p>
                        </div>
                        <div>
                            <h2>
                                <countTo :startVal=0 :endVal="8" :duration='3000' class="count" :decimals="0">
                                </countTo>
                                +<span>年</span>
                            </h2>
                            <p>农产品流通行业耕耘</p>
                        </div>
                        <div>
                            <h2>
                                <countTo :startVal=0 :endVal="25" :duration='3000' class="count" :decimals="0">
                                </countTo>
                                +<span>年</span>
                            </h2>
                            <p>软件产品设计经验</p>
                        </div>
                        <div>
                            <h2>
                                <countTo :startVal=0 :endVal="300" :duration='3000' class="count" :decimals="0">
                                </countTo>
                                +<span>位</span>
                            </h2>
                            <p>政企单位客户信赖</p>
                        </div>
                    </div>
                </div>

            </div>
            <!-- 轮播图模块 -->
            <div class="yetai">
                <div class="content_row">
                    <div class="title_content">
                        <div class="title">
                            <img src="../assets/tb.png" style="margin-right: .4rem;" alt="">
                            <h1>赋能各类业态，适配多样场景</h1>
                            <img src="../assets/tb 1.png" style="margin-left: .4rem;" alt="">
                        </div>
                        <p>满足不同角色需求，打造一站式智慧化解决方案</p>
                    </div>
                    <div class="lbt_content">
                        <div class="swiper mySwiper">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" id="jjfa-1">
                                    <img src="../assets/sznm.png" alt="数字农贸">
                                    <h2>数字农贸解决方案</h2>
                                    <p>数字农贸系统从人、物、资金、信息角度对农贸市场进行全方位数字化、智慧化升级改造。搭建“数字化基建、数字化管理、数字化营销”三大版块，满足不同角色（市场集团、管理员、商户、消费者）需求，为市场日常管理、增值服务、营销运营提供更多帮助。
                                    </p>
                                    <router-link to="/solution">
                                        <span>查看详细</span>
                                    </router-link>
                                </div>
                                <div class="swiper-slide" id="jjfa-2">
                                    <img src="../assets/zhnp.png" alt="数字农批">
                                    <h2>数字农批解决方案</h2>
                                    <p>围绕人、车、货、场进行全面数字化改造升级，整合物流、资金流、信息流，以提升农批市场综合运营与服务能力为目标，不仅对旧流程进行数字化升级再造，还对新生态进行引进融合。打造以商户为核心，运营服务为驱动力的新型智慧化农批市场。
                                    </p>
                                    <router-link to="/solution">
                                        <span>查看详细</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 视频组件 -->
            <div class="vedio_content">
                <div class="shopping">
                    <div class="title_content">
                        <div class="title">
                            <img src="../assets/tb.png" style="margin-right: .4rem;" alt="">
                            <h1>权威媒体报道</h1>
                            <img src="../assets/tb 1.png" style="margin-left: .4rem;" alt="">
                        </div>
                        <p>优秀的产品，优质的服务，权威的报道</p>
                    </div>
                    <div class="vedio">
                        <div class="content_row">
                            <video controls autoplay muted loop>
                                <source
                                    src="https://csy-software.oss-cn-hangzhou.aliyuncs.com/company/%E5%A4%AE%E8%A7%86%E5%8D%81%E4%B8%89%E9%A2%91%E9%81%93%E6%8A%A5%E9%81%93.mp4"
                                    type="video/mp4">
                                <source
                                    src="https://csy-software.oss-cn-hangzhou.aliyuncs.com/company/%E5%A4%AE%E8%A7%86%E5%8D%81%E4%B8%89%E9%A2%91%E9%81%93%E6%8A%A5%E9%81%93.mp4"
                                    type="video/webm">
                                您的浏览器不支持 HTML5 视频。
                            </video>
                            <span class="video_title">央视13频道2025年7月20日《共同关注》栏目报道我司实施的智慧市场</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 产品服务模块 -->
            <div class="content_row">
                <div class="fuwu">
                    <div class="title_content">
                        <div class="title">
                            <img src="../assets/tb.png" style="margin-right: .4rem;" alt="">
                            <h1>稳定、专业、丰富的云产品及服务</h1>
                            <img src="../assets/tb 1.png" style="margin-left: .4rem;" alt="">
                        </div>
                        <p>标准化输出，定制化升级，功能模块自由组合</p>
                    </div>
                    <div class="fuwu-box2">
                        <ul>
                            <li>
                                <img src="../assets/pic1.png" alt="人员管理">
                                <p>人员管理</p>
                            </li>
                            <li>
                                <img src="../assets/pic2.png" alt="智慧物联网">
                                <p>智慧物联网</p>
                            </li>
                            <li>
                                <img src="../assets/pic3.png" alt="物业管理">
                                <p>物业管理</p>
                            </li>
                            <li>
                                <img src="../assets/pic4.png" alt="食品安全追溯">
                                <p>食品安全追溯</p>
                            </li>
                            <li>
                                <img src="../assets/pic5.png" alt="电子化交易结算">
                                <p>电子化交易结算</p>
                            </li>
                            <li>
                                <img src="../assets/pic6.png" alt="会员运营">
                                <p>会员运营</p>
                            </li>
                            <li>
                                <img src="../assets/pic7.png" alt="车辆管理">
                                <p>车辆管理</p>
                            </li>
                            <li>
                                <img src="../assets/pic8.png" alt="数据可视化">
                                <p>数据可视化</p>
                            </li>
                            <li>
                                <img src="../assets/pic9.png" alt="进销存管理">
                                <p>进销存管理</p>
                            </li>
                            <li>
                                <img src="../assets/pic10.png" alt="智慧导视">
                                <p>智慧导视</p>
                            </li>
                            <li>
                                <img src="../assets/pic11.png" alt="O2O商城">
                                <p>O2O商城</p>
                            </li>
                            <li>
                                <img src="../assets/pic12.png" alt="数据赋能">
                                <p>数据赋能</p>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
            <!-- 销售模块 -->
            <div class="content_row">
                <div class="shopping">
                    <div class="title_content">
                        <div class="title">
                            <img src="../assets/tb.png" style="margin-right: .4rem;" alt="">
                            <h1>众多客户的选择，行业积淀的口碑</h1>
                            <img src="../assets/tb 1.png" style="margin-left: .4rem;" alt="">
                        </div>
                        <p>全国布点，业务覆盖广，服务更专业</p>
                    </div>
                    <div class="shopping-box2">
                        <dl>
                            <dt>售前</dt>
                            <dd>咨询指导</dd>
                            <dd>案例参观</dd>
                            <dd>在线演示</dd>
                            <dd>项目考察</dd>
                            <dd>方案讲解</dd>
                            <dd>制定方案</dd>
                        </dl>
                        <dl>
                            <dt>售中</dt>
                            <dd>进度把控</dd>
                            <dd>系统部署</dd>
                            <dd>初始配置</dd>
                            <dd>设备安装</dd>
                            <dd>弱电施工</dd>
                            <dd>驻点实施</dd>
                        </dl>
                        <dl>
                            <dt>售后</dt>
                            <dd>系统维护</dd>
                            <dd>系统升级</dd>
                            <dd>设备维修</dd>
                            <dd>在线客服</dd>
                            <dd>应急处理</dd>
                            <dd>增值服务</dd>
                        </dl>
                    </div>

                </div>
            </div>

            <!-- 合作伙伴模块 -->
            <div class="partner">
                <div class="title_content">
                    <div class="title">
                        <img src="../assets/tb.png" style="margin-right: .4rem;" alt="">
                        <h1>合作伙伴</h1>
                        <img src="../assets/tb 1.png" style="margin-left: .4rem;" alt="">
                    </div>
                    <p>合作伙伴全方面支持</p>
                </div>
            </div>

            <div class="partner-nav">
                <div class="content_row">
                    <div class="partner-nav-box1">
                        <ul>
                            <li>
                                <img src="../assets/p1.png" alt="H3C">
                            </li>
                            <li>
                                <img src="../assets/p2.png" alt="饿了么">
                            </li>
                            <li>
                                <img src="../assets/p3.png" alt="阿里巴巴">
                            </li>
                            <li>
                                <img src="../assets/p4.png" alt="中国工商银行">
                            </li>
                            <li>
                                <img src="../assets/p5..png" alt="中国电信">
                            </li>
                            <li>
                                <img src="../assets/p6.png" alt="中国移动">
                            </li>
                            <li>
                                <img src="../assets/p7.png" alt="客如云">
                            </li>
                            <li>
                                <img src="../assets/p8.png" alt="中国农业银行">
                            </li>
                            <li>
                                <img src="../assets/cp.png" alt="中国建设银行">
                            </li>
                            <li>
                                <img src="../assets/p10.png" alt="网商银行">
                            </li>
                            <li>
                                <img src="../assets/cp2.png" alt="中国银行">
                            </li>
                            <li>
                                <img src="../assets/cp3.png" alt="中国联通">
                            </li>
                            <li>
                                <img src="../assets/p9.png" alt="现代菜篮子">
                            </li>
                            <li>
                                <img style="width: .7rem !important;height:.7rem !important; margin-top:.17rem"
                                    src="../assets/jh.png" alt="金华市场发展集团">
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <BottomNav></BottomNav>
    </div>
</template>

<script>
import TopNav from '../components/TopNav.vue'
import BottomNav from '../components/BottomNav.vue'
import Swiper from 'swiper'; // 注意引入的是Swiper
import 'swiper/css/swiper.min.css' // 注意这里的引入
import CountTo from "vue-count-to"
export default {
    components: { TopNav, BottomNav, CountTo },
    data() {
        return {

        }
    },
    created() { },
    mounted() {
        var swiper = new Swiper(".mySwiper", {
            autoplay: true, //可选选项，自动滑动  initialSlide :0,
            observer: true,//修改swiper自己或子元素时，自动初始化swiper
            observeParents: true,//修改swiper的父元素时，自动初始化swiper
            slidesPerView: 1,
            spaceBetween: 30,
            centeredSlides: true,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            autoplay: {
                delay: 8000,
                disableOnInteraction: false,
            },
        });
    },
    methods: {}
}
</script>

<style lang="less" scoped>
.app {
    width: 100vw;
    height: 100vh;
    background-size: cover;
    z-index: -1;
    overflow-x: hidden;
}

.center {
    width: 100%;
    min-height: calc(100vh - .8333rem - 5.9063rem);
    margin-top: .8333rem;

    .pic {
        display: flex;
        justify-content: center;
        position: relative;
        width: 100%;
        height: 5.2083rem;
        background: url(../assets/bj.png) no-repeat center;
        background-size: 100% 100%;
        margin-top: .8333rem;
        z-index: -1;
    }

    .pic .w {
        width: 100%;
        padding: 0 4.25rem;
        margin-top: 4.4271rem;
        display: flex;
        justify-content: space-around;
    }

    .pic .w div {
        // float: left;
        width: 32%;
        height: 1.5625rem;
        background: #FFFFFF;
        box-shadow: 0px 0px .2604rem .0104rem rgba(35, 42, 36, 0.1);
        border-radius: .104rem;
        margin-right: .2083rem;
        box-sizing: border-box;
        padding: 0 .1042rem;
    }

    .pic .w div:nth-child(3) {
        margin-right: 0;
    }

    .pic .w div img {
        float: left;
        width: 1.25rem;
        height: 1.25rem;
        margin-top: .1563rem;
        margin-left: .1563rem;
        margin-right: .1563rem;
    }

    .pic .w div img {
        width: 1.25rem;
        height: 1.25rem;
    }

    .pic .w div h3 {
        height: .3542rem;
        font-size: .25rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #232A24;
        line-height: .3542rem;
        margin-top: .1042rem;
        margin-left: .1563rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .pic .w div p {
        height: .75rem;
        font-size: .1458rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #60646B;
        line-height: .25rem;
        margin-top: .1458rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }

    .history {
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
        width: 100%;
        height: 4.0417rem;
        margin-top: 1.4583rem;
        /* background-color: pink; */
        text-align: center;
        box-sizing: border-box;
    }



    .history h1 {
        height: .5rem;
        font-size: .3958rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #232A24;
        line-height: .5rem;
    }

    .history .title_content {
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        align-items: center;
    }

    .title_content .title {
        display: flex;
        align-items: center;
        color: #232A24;
    }

    .history .title_content img {
        width: 1.1458rem;
        height: .2292rem;
    }

    .history .title_content p {
        height: .3021rem;
        font-size: .2188rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #232A24;
        line-height: .3021rem;
        margin-top: .2917rem;
    }

    .history-time {
        display: flex;
        justify-content: space-around;
        width: 100%;
        height: 1.1458rem;
        margin-top: 1rem;
    }

    .history-time div {
        flex: 1;
        width: 100%;
        height: 100%;
        height: .5208rem;
    }

    .history-time div h2 .count {
        height: .7292rem;
        font-size: .625rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #08C667;
        line-height: .7292rem;
        margin-right: .0521rem;
        margin-bottom: .0313rem;
    }

    .history-time div span {
        height: .2604rem;
        font-size: .1875rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #60646B;
        line-height: .2604rem;
    }

    .history-time div p {
        height: .3125rem;
        font-size: .2292rem;
        font-family: PingFangTC-Regular, PingFangTC;
        font-weight: 400;
        color: #232A24;
        line-height: .3125rem;
    }
}

.yetai {
    overflow: hidden;
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 7.2396rem;
    background: url(../assets/bj2.png) no-repeat center;
    background-size: 100% 100%;
    text-align: center;
    box-sizing: border-box;
    padding-top: .6458rem;
}

.content_row {
    width: 100%;
    height: 100%;
    padding: 0 4.25rem;
    box-sizing: border-box;
}

.title_content {
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    align-items: center;
}

.title_content .title {
    display: flex;
    align-items: center;
}

.title_content img {
    width: 1.1458rem;
    height: .2292rem;
}

.title_content h1 {
    font-size: .3958rem;
}

.title_content p {
    height: .3021rem;
    font-size: .2188rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232A24;
    line-height: .3021rem;
    margin-top: .2917rem;
}

.lbt_content {
    margin-top: .5rem;
    height: 4.1rem;
}

.lbt_content .swiper {
    overflow: hidden;
    width: 100%;
    height: 100%;
}

.lbt_content .swiper-slide {
    position: relative;
    text-align: center;
    font-size: .1875rem;
    background: #fff;
    border: 1px solid #08C667;
}

.lbt_content .swiper-slide img {
    float: left;
    width: 5.2rem;
    height: 100%;
    margin-right: .2083rem;
}

.lbt_content .swiper-slide h2 {
    text-align: left;
    width: 100%;
    height: .3125rem;
    margin-top: .2604rem;
    color: #000;
}

.lbt_content .swiper-slide p {
    text-align: left;
    margin-top: .1563rem;
}

.lbt_content .swiper-slide span {
    position: absolute;
    text-align: center;
    bottom: .3125rem;
    right: .2083rem;
    line-height: .5rem;
    font-weight: 500;
    display: block;
    width: 2.0833rem;
    height: .5rem;
    background-color: #31b158;
    color: #fff;
    border-radius: .25rem;
}

.lbt_content .swiper-slide span:hover {
    color: #fff;
    background-color: #08C667;
    border: none;
}

.lbt_content.swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}


.fuwu {
    position: relative;
    width: 100%;
    text-align: center;
    box-sizing: border-box;
    height: 8.6042rem;
    padding-top: .7rem;
}


.fuwu-box2 {
    width: 100%;
    height: 5.8333rem;
    margin-top: .625rem;
}

.fuwu-box2 ul li {
    float: left;
    width: 16.6%;
    height: 2.9167rem;
}

.fuwu-box2 ul li img {
    width: 1.25rem;
    height: 1.25rem;
    box-shadow: 0px 0px .2604rem .0104rem rgba(35, 42, 36, 0.1);
}

.fuwu-box2 ul li img {
    width: 1.6667rem;
    height: 1.6667rem;
}

.fuwu-box2 ul li p {
    font-size: .25rem;
    font-weight: 400;
    color: #232a24;
    text-align: center;
    margin-top: .3125rem;
}


.shopping {
    position: relative;
    width: 100%;
    text-align: center;
    box-sizing: border-box;
    height: 6.3rem;
}

.shopping-box2 {
    width: 100%;
    height: 3.8542rem;
    margin-top: .625rem;
}

.shopping-box2 dl {
    float: left;
    width: 33.3%;
    box-sizing: border-box;
    border-right: .0208rem solid #60646B;
}

.shopping-box2 dl:nth-child(3) {
    border: none;
}

.shopping-box2 dt {
    margin-top: .3125rem;
    font-size: .3125rem;
    font-weight: 400;
    color: #232a24;
    text-align: center;
    margin-bottom: .2083rem;
}

.shopping-box2 dd {
    margin-top: .1563rem;
    font-size: .1875rem;
    font-weight: 400;
    color: #232a24;
    text-align: center;
}

.partner {
    position: relative;
    width: 100%;
    text-align: center;
    box-sizing: border-box;
    height: 2.0833rem;
}


.partner-nav {
    overflow: hidden;
    width: 100%;
    height: 6.8rem;
    background: url(../assets/bj3.png) no-repeat center;
    background-size: 100% 100%;
}

.partner-nav-box1 {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: space-between;
    width: 100%;
    text-align: center;
    margin-top: .5208rem;
    margin-left: .9792rem;
}

.partner-nav-box1 ul li {
    float: left;
    width: 20%;
    height: 1.0417rem;
    background-color: #fff;
    margin-top: .3125rem;
    margin-right: .2083rem;
    box-sizing: border-box;
    box-shadow: 0px 0px .2604rem .0104rem rgba(35, 42, 36, 0.1);
    z-index: 1;
}

.partner-nav-box1 ul li img {
    width: 1.25rem;
    height: .4167rem;
    margin-top: .3125rem;
}

.vedio_content {
    padding-top: .25rem;
    width: 100%;
    height: 8rem;
    // background-color: pink;
}

.vedio_content video {
    width: 100%;
    height: 100%;
    margin-top: .25rem;
}

.vedio {
    width: 100%;
    height: 6rem;
    box-sizing: border-box;
}

.video_title {
    margin-top: .15rem;
    font-size: .2rem;
}
</style>